import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M16.875 0H3.125C1.40188 0 0 1.40188 0 3.125V3.16406C0 4.88719 1.40188 6.28906 3.125 6.28906C3.13816 6.28906 3.15105 6.28773 3.16406 6.28707V16.875C3.16406 18.5981 4.56594 20 6.28906 20H13.75C15.4731 20 16.875 18.5981 16.875 16.875C16.875 16.4435 16.5252 16.0938 16.0938 16.0938C15.6623 16.0938 15.3125 16.4435 15.3125 16.875C15.3125 17.7366 14.6116 18.4375 13.75 18.4375H6.28906C5.4275 18.4375 4.72656 17.7366 4.72656 16.875V1.5625H15.3125V12.9688C15.3125 13.4002 15.6623 13.75 16.0938 13.75C16.5252 13.75 16.875 13.4002 16.875 12.9688V6.28906C18.5981 6.28906 20 4.88719 20 3.16406V3.125C20 1.40188 18.5981 0 16.875 0ZM3.16406 4.72855C3.15105 4.72789 3.13816 4.72656 3.125 4.72656C2.26344 4.72656 1.5625 4.02563 1.5625 3.16406V3.125C1.5625 2.26344 2.26344 1.5625 3.125 1.5625H3.16406V4.72855ZM18.4375 3.16406C18.4375 4.02563 17.7366 4.72656 16.875 4.72656V1.5625C17.7366 1.5625 18.4375 2.26344 18.4375 3.125V3.16406Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M10.0048 6.44531C7.89394 6.44531 6.17664 8.03992 6.17664 10C6.17664 11.9601 7.89394 13.5547 10.0048 13.5547C12.1156 13.5547 13.8329 11.9601 13.8329 10C13.8329 8.03992 12.1156 6.44531 10.0048 6.44531ZM10.0048 11.9922C8.75551 11.9922 7.73914 11.0985 7.73914 10C7.73914 8.90148 8.75551 8.00781 10.0048 8.00781C11.254 8.00781 12.2704 8.90148 12.2704 10C12.2704 11.0985 11.2541 11.9922 10.0048 11.9922Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M10.0391 16.9922C10.4705 16.9922 10.8203 16.6424 10.8203 16.2109C10.8203 15.7795 10.4705 15.4297 10.0391 15.4297C9.60759 15.4297 9.25781 15.7795 9.25781 16.2109C9.25781 16.6424 9.60759 16.9922 10.0391 16.9922Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M10.0391 4.57031C10.4705 4.57031 10.8203 4.22053 10.8203 3.78906C10.8203 3.35759 10.4705 3.00781 10.0391 3.00781C9.60759 3.00781 9.25781 3.35759 9.25781 3.78906C9.25781 4.22053 9.60759 4.57031 10.0391 4.57031Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ]))
}